export default class DtoQuantifications {
    constructor(obj) {
        this.parameter = obj[0]
        this.total = obj[1]
        this.quantifications = obj[2]
    }
}